import { dataFetch } from '@lib/ggj-utils'

export default {
  showYm(params) {
    return dataFetch('/wholesale/api/income/showYm', params, { method: 'get', headers: { 'gj-ua': 4 } })
  },
  // 收益首页-头部
  getIncomeHeadData(params) {
    return dataFetch('/wholesale/api/income/home/head', params, {
      method: 'get',
    })
  },
  // 收益首页-主体
  getIncomeBodyData(params) {
    return dataFetch('/wholesale/api/income/home/body', params, {
      method: 'get',
    })
  },
  // 月数据详情
  getIncomeMonthDetail(params) {
    return dataFetch('/wholesale/api/income/month/detail', params, {
      method: 'get',
    })
  },
  // 月数据订单列表
  getIncomeMonthOrder(params) {
    return dataFetch('/wholesale/api/income/month/order', params, {
      method: 'get',
    })
  },
  // 结算数据
  getIncomeSettleInfo(params) {
    return dataFetch('/wholesale/api/income/settle/info', params, {
      method: 'get',
    })
  },
  // 已结算月数据详情
  getIncomeSettleMonthDetail(params) {
    return dataFetch('/wholesale/api/income/settle/month/detail', params, {
      method: 'get',
    })
  },
  // 预期收益
  getPredict(params) {
    return dataFetch('/wholesale/api/income/predict', params, {
      method: 'get',
    })
  },
  //判断转赠身份
  bindStatus(params) {
    return dataFetch('/member-web/api/income/bind/status', params, {
      method: 'get',
    })
  },

  canBaskEarnings(params) {
    return dataFetch('/wholesale-activity/api/earningsTool/canBaskEarnings', params, {
      method: 'get',
    })
  },
  // 判断是否是首次访问
  async isFirst(params) {
    return dataFetch('/wholesale/api/management/home/guide/check', params, { method: 'get' })
  },


  async signStatus(params) {
    return dataFetch('/wholesale/api/contract/sign/status', params, { method: 'get' })
  },
  async personContract(params) {
    return dataFetch('/wholesale/api/contract/sign/personContract', params, { method: 'post' })
  },
  async certificationInfo(params) {
    return dataFetch('/cashier-desk/api/user/bank/query/certification/info', params, { method: 'get' })
  },
  async withdrawPreview(params) {
    return dataFetch('/member-web/api/fission/withdrawPreview', params, { method: 'get' })
  },

		async withdrawalCalculate(params) {
		return dataFetch('/wholesale/api/withdrawal/apply/calculate', params, { method: 'post' })
	},
  	async fissionMyIncome(params) {
		return dataFetch('/member-web/api/fission/myIncome', params, { method: 'get' })
	},

  async monthIncomeDetail(params) {
		return dataFetch('/member-web/api/fission/monthIncomeDetail', params, { method: 'get' })
	},

  async videoMonthSummary(params) {
		return dataFetch('/member-web/api/videoChannel/monthSummary', params, { method: 'get' })
	},

  async videoMonthDetail(params) {
		return dataFetch('/member-web/api/videoChannel/monthDetail', params, { method: 'get' })
	},

  async inWhiteList(params) {
    return dataFetch('/wholesale/api/invoice/info/inWhiteList', params, { method: 'get' })
  },

  async withdrawApply(params) {
    return dataFetch('/wholesale/api/withdrawal/apply/person/submit', params, { method: 'post' })
  },

  async withdrawList(params) {
    return dataFetch('/wholesale/api/withdrawal/apply/list', params, { method: 'post' })
  },
  async personCalculate(params) {
    return dataFetch('/wholesale/api/withdrawal/apply/person/calculate', params, { method: 'post' })
  },
}

